// Asset di brand: logo ElevenBase intero (scudo + wordmark) + monogramma "FC".
// Lo scudo da solo si usa solo nelle favicon o dove l'intero sarebbe illeggibile.
import { cn } from "@v2/lib/utils";

export const ELEVENBASE_LOGO_URL = "/site-logo.png";

export function BrandMark({
  size = "md",
  onBrand = false,
  className,
}: {
  size?: "sm" | "md" | "lg" | "xl";
  onBrand?: boolean;
  className?: string;
}) {
  // Aspect ratio del logo intero (~3.2:1). Definiamo solo l'altezza, larghezza auto.
  const heightClass =
    size === "sm" ? "h-6" : size === "lg" ? "h-12" : size === "xl" ? "h-16" : "h-9";
  return <span role="img" aria-label="ElevenBase" className={cn(heightClass, "eb-logo select-none", onBrand && "eb-logo-on-brand", className)} />;
}

// Testata delle superfici istituzionali (accesso, inviti, pagine pubbliche):
// i colori del logo a tutta larghezza, con il logo in chiaro.
export function BrandHero({ children, className }: { children?: React.ReactNode; className?: string }) {
  return (
    <div className={cn("eb-brand-hero px-5 pt-[max(2rem,env(safe-area-inset-top))] pb-6", className)}>
      <BrandMark size="lg" onBrand />
      {children}
    </div>
  );
}

// "FC" del logo EA Sports FC: triangolo + arco "C", estratto dal SVG ufficiale.
export function FcIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="50 5 51 47" fill="currentColor" {...props}>
      <path d="M54.1819 8.06403L59.6631 17.5305L65.1795 8.06403H54.1819Z" />
      <path d="M66.0442 21.8664H75.0141L78.5553 15.7833H69.5796L70.5671 14.0887H79.5429L83.0548 8.06403C83.0548 8.06403 72.1566 8.06403 69.825 8.06403C67.3006 8.06403 65.8222 10.343 65.8222 10.343L60.6448 19.2251L64.1042 25.1914L66.0442 21.8664Z" />
      <path d="M84.054 25.2264L77.5501 36.3934L76.5684 34.6988L88.5594 14.1237H90.5287L85.0416 23.5376H91.9603L100.93 8.06403C100.93 8.06403 89.4593 8.06403 87.5777 8.06403C85.1409 8.06403 83.7092 10.3313 83.7092 10.3313C83.7092 10.3313 70.941 32.2562 70.9294 32.2562C70.2749 33.5768 70.2749 35.7272 70.941 36.966C70.9527 36.9894 77.5559 48.3784 77.5559 48.3784L90.9845 25.2147H84.054V25.2264Z" />
    </svg>
  );
}
